import { useTheme } from '@emotion/react';
import CallMadeIcon from '@mui/icons-material/CallMade';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { Box, Button } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useContext, useState } from 'react';
import { LoginContext } from '../contexts/LoginContext';
import { PackageType } from '../enums/packageTypes';
import getAllSubscriptionsService from '../services/OwnTestCreationServices/getAllSubscriptionsService';
import styles from '../styles/Home.module.css';


export default function OwnTestCreationCard({ image, cardDescription }) {

    const theme = useTheme();
    const { setPageKey, setAssessmet, setTestSeriesCardStatus, setTopicId, packageId } = useContext(LoginContext)
    const [pickYourTestPrice, setPickYourTestPrice] = useState();
    async function oncall(courseId, testSeriesCardStatus) {
        setPageKey(5)
        console.log("testseriescarsstatus", testSeriesCardStatus);
        setTestSeriesCardStatus(testSeriesCardStatus)
        setTopicId(courseId);
        setAssessmet(false)
    }
    const getSubscriptionsDetails = async () => {
        const subscriptions = await getAllSubscriptionsService();
        setPickYourTestPrice(subscriptions[0]?.price);
        return
    }
    useState(() => {
        getSubscriptionsDetails();
    }, [])
    return (
        <Box sx={{ position: 'relative', margin: 2 }}>
            <Card className={styles.Rectangle8}>
                <div>
                    {image && <img src={image} alt={"No Image"} style={{ width: '100%', height: '200px ' }} />}
                </div>
                <CardContent style={{ height: '180px', cursor: 'context-menu' }}>
                    <Box>
                        <div className={styles.TestSeriesTitle}>{"Topic Pulse"}</div>
                        <Typography variant="body2" calssName={styles.cardDescription} style={{ listStyleType: 'disc', fontSize: '12px', textAlign: 'left', height: '95px', fontFamily: 'Poppins' }}>
                            {cardDescription}
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'right', alignItems: 'center', marginTop: '10px', borderTop: '1px solid #cacaca' }}>

                        {/* Price on the left side */}
                        <span className={styles.price}>
                            <LocalOfferIcon className={styles.priceTag} /> {`₹ ${pickYourTestPrice || 0}`}
                        </span>
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'right', alignItems: 'center', marginTop: '10px' }}>
                        <Button className={styles.Rectangle25} onClick={() => { setPageKey(9) }} disabled={packageId && packageId === PackageType.TRIAL}>
                            {/* {`₹ ${price || 0}`} */}
                            Buy Plan  <CallMadeIcon />
                        </Button>
                    </Box>
                </CardContent >
            </Card >
        </Box >
    );
}